<template>
  <div class="ec-line040">
    <div v-if="hasError">
      <el-breadcrumb separator="/" class="mt-7">
        <el-breadcrumb-item>
          <a :href="baseUrl">{{ shopName }}</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: $routePage.EC_LINE039 }">
          {{ $t('ec-line040.title') }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ $t('ec-line040.message.connectErrorMessage') }}
        </el-breadcrumb-item>
      </el-breadcrumb>

      <TheHeading class="line-error-heading">
        {{ $t('ec-line040.message.connectErrorMessage') }}
      </TheHeading>
      <TheSection class="custom-padding">
        <div class="message-and-form">
          <div class="error-messages">
            <div v-for="(message, index) in errorMessages" :key="index" class="error-message">
              {{ message }}
            </div>
          </div>
          <el-form v-if="showForm" ref="form" :model="form" label-position="top" @submit.native.prevent="onSubmit">
            <el-form-item>
              <line-button v-if="!showLoginButton" @click="onSubmit">
                {{ $t('common.action.lineLink') }}
              </line-button>
              <line-button v-else class="el-button rounded-full font-black w-60 mb-8" @click="loginLine">
                {{ $t('ec-line031.content.form.lineLogin') }}
              </line-button>
            </el-form-item>
          </el-form>
        </div>
      </TheSection>
    </div>

    <line-link-success-dialog :visible.sync="visible"></line-link-success-dialog>
  </div>
</template>

<script>
import LineLinkSuccessDialog from '@/components/line-link/LineLinkSuccessDialog.vue'
import LineButton from '@/components/LineButton.vue'
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import TheSection from '@/components/TheSection.vue'
import liff from '@line/liff'
import mixinAuth from '@/mixins/auth'
import mixinLine from '@/mixins/ec-line029/line'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import { LineLinkService } from '@/services'
import { APP_STATUS, LINE_LOGIN_FROM_LOGIN_PAGE } from '@/constants'
import { ENV_KEY } from '@/constants/env'

export default {
  mixins: [mixinAuth, BreadcrumbMixin, mixinLine],
  components: {
    LineLinkSuccessDialog,
    LineButton,
    TheHeading,
    TheSection,
  },

  data() {
    return {
      visible: false,
      errorType: '',
    }
  },

  computed: {
    hasError() {
      return this.errorType !== ''
    },
    errorMessages() {
      switch (this.errorType) {
        case 'timeout':
          return [
            this.$t('ec-line040.content.timeoutLinkErrMessage1'),
            this.$t('ec-line040.content.timeoutLinkErrMessage2'),
          ]
        case 'used':
          return [this.$t('ec-line040.content.usedLinkErrMessage1'), this.$t('ec-line040.content.usedLinkErrMessage2')]
        case 'other':
          return [
            this.$t('ec-line040.content.otherErrMessage1'),
            this.$t('ec-line040.content.otherErrMessage2'),
            this.$t('ec-line040.content.otherErrMessage3'),
          ]
        default:
          return []
      }
    },
    showForm() {
      return this.errorType === 'timeout' || this.errorType === 'used'
    },
    showLoginButton() {
      return this.errorType === 'used'
    },
  },

  async created() {
    const token = this.$route.query.token

    if (!token) {
      this.$router.push(this.$routePage.EC_LINE039)
      return
    }

    await this.confirmEmail(token)
  },

  methods: {
    async confirmEmail(token) {
      try {
        await LineLinkService.confirmEmail(token)
        this.visible = true
      } catch (error) {
        const code = error.response?.data?.meta?.app_status_code
        if (code === APP_STATUS.TOKEN_IS_EXPIRE || code === APP_STATUS.TOKEN_MUST_NOT_BE_EMPTY) {
          this.errorType = 'timeout'
        } else if (code === APP_STATUS.THIS_URL_HAD_BEEN_USED) {
          this.errorType = 'used'
        } else {
          this.errorType = 'other'
        }
      }
    },
    loginLine() {
      const url = new URL(
        `${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${process.env.VUE_APP_PREFIX}${
          this.$routePage.EC_LINE009
        }`
      )
      url.searchParams.append(LINE_LOGIN_FROM_LOGIN_PAGE, true)

      if (this.liffIdExists) {
        liff.login({
          redirectUri: url.toString(),
        })
      }
    },
    onSubmit() {
      this.$router.push(this.$routePage.EC_LINE039)
    },
  },
  metaInfo() {
    return {
      title: this.$t('lineLink.metaTitle'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('lineLink.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('lineLink.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/ec-line040.scss';
</style>
